<template>
  <app-resizable-dropdown
    ref="dropdownRef"
    class="app-dropdown"
    :position="position"
    :trigger="isMobile ? 'click' : type === 'menu' ? 'hover' : 'click'"
    :hover-delay="300"
    :hover-close-delay="1000"
    :resizable="false"
    :close-by-click-outside="true"
    :mobile-title="$t('contact_choose_action')"
    @open="isOpen = true"
    @close="handleClose"
  >
    <template #activator>
      <app-button
        v-if="type === 'default'"
        :label="label"
        :disabled="disabled"
        :active="isOpen"
        :width="width"
        type="dropdown"
      />
      <app-icon
        v-else
        name="options-menu"
        width="16px"
        color="#979797"
        cursor="pointer"
        hover-color="#499259"
        @pointerdown="blurActiveEditorOnMobile"
      />
    </template>

    <slot :onSelect="handleSelect" />
  </app-resizable-dropdown>
</template>

<script setup lang="ts">
import { ref } from "vue";
import AppButton from "../ui-kit/button/AppButton.vue";
import AppIcon from "../ui-kit/icon/AppIcon.vue";
import AppResizableDropdown from "../ui-kit/dropdown/AppResizableDropdown.vue";
import { useBreakpoints } from "@/composables/useBreakpoints";

type DropdownProps = {
  position?: "left" | "right";
  label?: string;
  disabled?: boolean;
  width?: string;
  type: string;
};

type DropdownEmits = {
  "on-close": [];
  select: [option: string];
};

const props = withDefaults(defineProps<DropdownProps>(), {
  position: "right",
  label: "Menu",
  disabled: false,
  width: "",
  type: "default",
});

const emit = defineEmits<DropdownEmits>();
const { isMobile } = useBreakpoints();

const dropdownRef = ref<InstanceType<typeof AppResizableDropdown> | null>(null);
const isOpen = ref(false);

const closeDropdown = () => {
  dropdownRef.value?.close();
};

const blurActiveEditorOnMobile = () => {
  if (!isMobile.value) return;

  const activeElement = document.activeElement;
  if (
    activeElement instanceof HTMLElement &&
    activeElement.matches('input, textarea, [contenteditable="true"]')
  ) {
    activeElement.blur();
  }
};

const handleClose = () => {
  isOpen.value = false;
  emit("on-close");
};

const handleSelect = (option: string) => {
  closeDropdown();
  emit("select", option);
};

defineExpose({ closeDropdown });
</script>
